import { ColumnModel } from "./column.model";

export interface TableConfigModel {
    columns: ColumnModel[]
}